export type OfferVisualIconName = 'trophy' | 'sparkles' | 'ticket' | 'check' | 'clock' | 'calendar' | 'warning';

export function OfferVisualIcon({ name }: { name: OfferVisualIconName }) {
  if (name === 'trophy') {
    return (
      <span className="offer-campaign-icon" data-icon={name} aria-hidden="true">
        <svg viewBox="0 0 24 24" fill="none"><path d="M8 21h8M12 17v4M7 4h10v5a5 5 0 0 1-10 0V4Z" /><path d="M7 6H4v2a4 4 0 0 0 4 4M17 6h3v2a4 4 0 0 1-4 4" /></svg>
      </span>
    );
  }
  if (name === 'sparkles') {
    return (
      <span className="offer-campaign-icon" data-icon={name} aria-hidden="true">
        <svg viewBox="0 0 24 24" fill="none"><path d="m12 3 1.8 5.2L19 10l-5.2 1.8L12 17l-1.8-5.2L5 10l5.2-1.8L12 3Z" /><path d="m19 15 .8 2.2L22 18l-2.2.8L19 21l-.8-2.2L16 18l2.2-.8L19 15Z" /></svg>
      </span>
    );
  }
  if (name === 'ticket') {
    return (
      <span className="offer-campaign-icon" data-icon={name} aria-hidden="true">
        <svg viewBox="0 0 24 24" fill="none"><path d="M3 9a3 3 0 0 0 0 6v3h18v-3a3 3 0 0 0 0-6V6H3v3Z" /><path d="M9 9h.01M15 15h.01M15 9l-6 6" /></svg>
      </span>
    );
  }
  if (name === 'check') {
    return (
      <span className="offer-campaign-icon" data-icon={name} aria-hidden="true">
        <svg viewBox="0 0 24 24" fill="none"><circle cx="12" cy="12" r="9" /><path d="m8 12 2.5 2.5L16 9" /></svg>
      </span>
    );
  }
  if (name === 'clock') {
    return (
      <span className="offer-campaign-icon" data-icon={name} aria-hidden="true">
        <svg viewBox="0 0 24 24" fill="none"><circle cx="12" cy="12" r="9" /><path d="M12 7v5l3 2" /></svg>
      </span>
    );
  }
  if (name === 'calendar') {
    return (
      <span className="offer-campaign-icon" data-icon={name} aria-hidden="true">
        <svg viewBox="0 0 24 24" fill="none"><rect x="3" y="5" width="18" height="16" rx="2" /><path d="M16 3v4M8 3v4M3 10h18" /><path d="M8 14h.01M12 14h.01M16 14h.01M8 18h.01M12 18h.01" /></svg>
      </span>
    );
  }
  return (
    <span className="offer-campaign-icon" data-icon={name} aria-hidden="true">
      <svg viewBox="0 0 24 24" fill="none"><path d="M12 3 2 20h20L12 3Z" /><path d="M12 9v5M12 17h.01" /></svg>
    </span>
  );
}
